import { COLLECT_TESTS, FB_URL } from "./types";
import firebase from "../firebase";
import axios from 'axios';

import ImagePanoramaFishEye from "material-ui/svg-icons/image/panorama-fish-eye";
const {v4: uuidv4} = require('uuid')

function fillup(strIn) {
  if (!strIn) return '';
  
  var str = strIn.toString();
  
  // Replace spaces with underscores
  str = str.split(' ').join('_');
  
  // Remove or replace Firebase invalid characters
  // Firebase paths cannot contain: . # $ [ ] / and some special chars
  str = str.replace(/\./g, '_dot_')     // Replace periods
            .replace(/#/g, '_hash_')     // Replace hash
            .replace(/\$/g, '_dollar_')  // Replace dollar
            .replace(/\[/g, '_lbracket_') // Replace left bracket
            .replace(/\]/g, '_rbracket_') // Replace right bracket
            .replace(/\//g, '_slash_')   // Replace forward slash
            .replace(/%/g, '_percent_')  // Replace percent
            .replace(/\?/g, '_question_') // Replace question mark
            .replace(/</g, '_lt_')       // Replace less than
            .replace(/>/g, '_gt_')       // Replace greater than
            .replace(/"/g, '_quote_')    // Replace quotes
            .replace(/'/g, '_apostrophe_') // Replace apostrophes
            .replace(/\*/g, '_star_')    // Replace asterisk
            .replace(/\+/g, '_plus_')    // Replace plus
            .replace(/=/g, '_equals_')   // Replace equals
            .replace(/,/g, '_comma_')    // Replace comma
            .replace(/;/g, '_semicolon_') // Replace semicolon
            .replace(/:/g, '_colon_')    // Replace colon
            .replace(/\|/g, '_pipe_')    // Replace pipe
            .replace(/\\/g, '_backslash_') // Replace backslash
            .replace(/\(/g, '_lparen_')  // Replace left parenthesis
            .replace(/\)/g, '_rparen_')  // Replace right parenthesis
            .replace(/&/g, '_and_')      // Replace ampersand
            .replace(/\^/g, '_caret_')   // Replace caret
            .replace(/~/g, '_tilde_')    // Replace tilde
            .replace(/`/g, '_backtick_') // Replace backtick
            .replace(/@/g, '_at_')       // Replace at symbol
            .replace(/!/g, '_exclamation_'); // Replace exclamation
  
  // Limit length to prevent extremely long paths
  if (str.length > 100) {
    str = str.substring(0, 100);
  }
  
  return str;
}

// export const checkTestDone = async (
//   isCompanyID,
//   surveyid,
//   personid,
//   thoughtID
// ) => {
//   try {
//     const snapshot = await firebase
//       .database
//       .ref(`surveysTests/${isCompanyID}/${surveyid}/${personid}`)
//       .once("value");
//     console.log('checkTestDone 1: ', isCompanyID);

//     if (!snapshot.exists()) return false;

//     const data = snapshot.val();
//     console.log('checkTestDone 2: ', data);
//     console.log('checkTestDone 3: ', data.testPassed);

//     return data.thoughtID === thoughtID && data.testPassed === true;

//   } catch (error) {
//     console.error(error);
//     return false;
//   }
// };

export const appendTest = params => {
  if (params.type === COLLECT_TESTS) {
    var isCompanyID;
    if (params.real_companyID) {
      isCompanyID = params.real_companyID;
    }
     else
    {
      isCompanyID = params.companyID;
    } 
    return (dispatch, getState) => {
        var timeInMs = Date.now();
        var dbaseAppend = firebase.database;

        // Enrich record using survey metadata and store in both survey and user-centric paths
        const surveyMetaRef = dbaseAppend.ref(`surveys/${isCompanyID}/${params.surveyid}`);
        return surveyMetaRef.once('value').then(async (snapshot) => {
          const surveyMeta = snapshot.val() || {};
          const categoryType = surveyMeta.categoryType || 'general';
          const difficultyUsed = params.difficulty || params.testComplexity || surveyMeta.testComplexity || 'basic';
          const testSource = surveyMeta.testSource || 'content';

          // Try to infer medium type from post
          let mediumType = 'content';
          // These will be used to persist lead category info on the test record
          let derivedLeadCategory = '';
          let derivedLeadSubCategory = '';
          let postRefData = null;
          try {
            let postSnap = await dbaseAppend.ref(`dailyThoughts/${params.surveyid}`).once('value');
            let post = postSnap.val();
            if (!post) {
              postSnap = await dbaseAppend.ref(`company-group-posts/${isCompanyID}/${params.surveyid}`).once('value');
              post = postSnap.val();
            }
            if (post) {
              postRefData = post;
              const hasVideos = post.videos && Object.keys(post.videos).length > 0;
              const hasPodcasts = post.podcasts && Object.keys(post.podcasts).length > 0;
              const hasFiles = post.files && Object.keys(post.files).length > 0;
              const hasUrls = post.urls && Object.keys(post.urls).length > 0;
              if (hasVideos) mediumType = 'video';
              else if (hasPodcasts) mediumType = 'podcast';
              else if (hasFiles) {
                try {
                  const firstKey = Object.keys(post.files)[0];
                  const file = post.files[firstKey] || {};
                  if ((file.filename || '').toLowerCase().endsWith('.pdf') || (file.url || '').toLowerCase().endsWith('.pdf')) {
                    mediumType = 'pdf';
                  } else {
                    mediumType = 'file';
                  }
                } catch (_) { mediumType = 'file'; }
              } else if (hasUrls) {
                mediumType = 'article';
              }
              // Enrich with lead category and sub-category when available on the post
              try {
                // Category can be stored under multiple possible keys depending on source
                const possibleCategoryKeys = [
                  'competency', 'category', 'competencyName', 'leadCategory', 'thoughtCategory',
                  'type', 'competencytype', 'categoryType'
                ];
                for (const key of possibleCategoryKeys) {
                  if (post[key] && String(post[key]).trim() !== '') { derivedLeadCategory = String(post[key]); break; }
                }

                // Sub-category can also be saved under different keys
                const possibleSubKeys = [
                  'subcompetency', 'subCategory', 'subcategory', 'subCompetency', 'subcompetencyname', 'subcompetencyName', 'valueDesc'
                ];
                for (const key of possibleSubKeys) {
                  if (post[key] && String(post[key]).trim() !== '') { derivedLeadSubCategory = String(post[key]); break; }
                }
              } catch (_) { /* ignore */ }
            } else {
              mediumType = testSource === 'transcript' ? 'video' : 'content';
            }
          } catch (_) {
            mediumType = testSource === 'transcript' ? 'video' : 'content';
          }

          const totalAnswered = (params.totalAnswered && params.totalAnswered > 0) ? params.totalAnswered : (params.qlen || 0);
          const percentage = totalAnswered > 0 ? ((parseInt(params.counterCorrectAnswers || 0) / parseInt(totalAnswered)) * 100).toFixed(1) : '0.0';

          const testRecord = {
            surveyname: params.surveyTitle || (surveyMeta.title || ''),
            personid: params.personid,
            personname: (params.personName || '') + ' ' + (params.personLname || ''),
            testscore: params.counterCorrectAnswers,
            qlen: params.qlen,
            totalAnswered: totalAnswered,
            percentage: percentage,
            testPassed: params.testPassed,
            difficulty: difficultyUsed,
            lcEarned: params.lcEarned,
            categoryType: categoryType,
            mediumType: mediumType,
            testSource: testSource,
            timestamp: params.timestamp || timeInMs,
            thoughtID: params.thoughtID || params.surveyid,
            title: params.title || surveyMeta.title || '',
            // Prefer values derived from the post when available; fallback to survey metadata
            leadCategory: (derivedLeadCategory && derivedLeadCategory.trim() !== '') ? derivedLeadCategory : (postRefData && (postRefData.competency || postRefData.category)) || categoryType,
            leadSubCategory: (derivedLeadSubCategory && derivedLeadSubCategory.trim() !== '') ? derivedLeadSubCategory : (postRefData && (postRefData.subcompetency || postRefData.subCategory || postRefData.subcategory)) || ''
          };

          var updates = {};
          // Legacy flat path (no groupID)
          const legacyPath = `surveysTests/${isCompanyID}/${params.surveyid}/${params.personid}`;
          Object.keys(testRecord).forEach((k) => {
            if (testRecord[k] !== undefined) {
              updates[legacyPath + '/' + k] = testRecord[k];
            }
          });

          // Grouped path used by stats modal (companyID/groupID/surveyid/personid)
          const groupIdForStats = params.groupID || params.thoughtID || params.surveyid;
          const groupedPath = `surveysTests/${isCompanyID}/${groupIdForStats}/${params.surveyid}/${params.personid}`;
          Object.keys(testRecord).forEach((k) => {
            if (testRecord[k] !== undefined) {
              updates[groupedPath + '/' + k] = testRecord[k];
            }
          });

          // IMPORTANT: Index user results under the CURRENT USER'S company for consistent lookup in UI
          const stateUser = (getState && getState().userDialog && getState().userDialog.userDetails && getState().userDialog.userDetails[0]) || {};
          const currentUserCompanyID = stateUser.real_companyID || stateUser.companyID || params.companyID || isCompanyID;
          const userPath = 'userTestResults/' + currentUserCompanyID + '/' + params.personid + '/' + params.surveyid;
          console.log('appendTest-userTestResults 1: ', userPath);
          Object.keys(testRecord).forEach((k) => {
            if (testRecord[k] !== undefined) {
              updates[userPath + '/' + k] = testRecord[k];
              console.log('appendTest-userTestResults 2: ', userPath + '/' + k);
            }
          });

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                    updates: updates, //user wallet address                       
                }
              })

          if (res.data || res.data.success === true) {
             console.log("checkTestDone 5: Test Lc awarded");
              dispatch({
                type: COLLECT_TESTS,
                testresult: params.surveyid
              });         
           }
          else {
              dispatch({
                type: COLLECT_TESTS,
                message: 'error in appendTest class'
              });
          }; 

          // return dbaseAppend.ref().update(updates)
          //   .then(() => {
          //     dispatch({
          //       type: COLLECT_TESTS,
          //       testresult: params.surveyid
          //     });
          //   })
          //   .catch(err => {
          //     dispatch({
          //       type: COLLECT_TESTS,
          //       message: err.message
          //     });
          //   });
        });

      };
     }
    };
     